import {NgModule} from "@angular/core";
import {SharedModule} from "../../shared.module";
import {DatatableEditableComponent} from "./datatable-editable/datatable-editable.component";
import {SelectComponent} from './form/select/select.component';
import {FormComponent} from "./form/form-component/form.component";
import {ReloadComponent} from './form/reload/reload.component';
import {SelectModule} from "ng2-select-compat";
import {MultiselectModule} from "../multiselect/multiselect.module";
import {AssignmentSelectComponent} from "./form/select/assignment/select.component";
import {AssignmentSelectMultipleComponent} from "./form/select/assignment/select-multiple.component";
import {AssignmentSelectMultipleCheckComponent} from "./form/select/assignment/select-multiple-check.component";
import {MyCheckModule} from "../my-check/my-check.module";
import {InputComponent} from './form/input/input.component';
import {CheckboxComponent} from './form/checkbox/checkbox.component';
import {TextareaComponent} from './form/textarea/textarea.component';
import {DataTablesModule} from "angular-datatables";


@NgModule({
  declarations: [
	  DatatableEditableComponent,
      FormComponent,
      ReloadComponent,
	  SelectComponent,
      InputComponent,
	  CheckboxComponent,
      TextareaComponent,
	  AssignmentSelectComponent,
	  AssignmentSelectMultipleComponent,
	  AssignmentSelectMultipleCheckComponent
  ],
  imports: [
      DataTablesModule,
	  MyCheckModule,
	  SharedModule,
      SelectModule,
      MultiselectModule
  ],
  exports: [
	  DatatableEditableComponent
  ]
})
export class DatatableEditableModule {} // end class DatatableObjectModule
